/* eslint-disable max-len */
export default [
  {
    url: 'home',
    title: 'Home | 7glyphs',
    description: '7 glyphs will help you materialize your ideas into the perfect product: simple, intuitive, and elegant, specifically tailored to complement the needs of your business.'
  },
  {
    url: 'services',
    title: 'Services | 7glyphs',
    description: 'At 7 glyphs, we combine our passion for creation with the best technologies and services available today. We\'ll be with you in every step of the process.'
  },
  {
    url: 'packages',
    title: 'Packages | 7glyphs',
    description: '7 glyphs offers plenty of packages that will cater to any software development needs. Our goal is to build a software that adheres to the client’s expectations.'
  },
  {
    url: 'process',
    title: 'Process | 7glyphs',
    description: 'Our work process is similar to launching a space shuttle in that we have to pay attention to the smallest details.'
  },
  {
    url: 'technologies',
    title: 'Technologies | 7glyphs',
    description: 'At 7 glyphs, we use our proven know-how, modern methods and tools to ensure that the system is built properly in every aspect.'
  },
  {
    url: 'projects',
    title: 'Projects | 7glyphs',
    description: 'Perfectly crafted mobile and web applications. We build beautiful, simple and highly functional products for mobile and web platforms.'
  },
  {
    url: 'clients',
    title: 'Clients | 7glyphs',
    description: 'Our clients are our inspiration in everything that we do. The variety of case studies we conducted have proven that we can deliver anything that the client wants.'
  },
  {
    url: 'company',
    title: 'Agency | 7glyphs',
    description: 'The 7 glyphs approach is focused around the 7 aspects of product development. We believe those aspects make any idea successful and allows us to build great products.'
  },
  {
    url: 'team',
    title: 'Team | 7glyphs',
    description: 'Every person in our team is an expert in their field. We recruit the best design and development talent around.'
  },
  {
    url: 'office',
    title: 'Office | 7glyphs',
    description: 'We are a team of awesome, inspired, creative people who enjoy what they do and take pride in their job.'
  },
  {
    url: 'blog',
    title: 'Blog | 7glyphs',
    description: 'We strongly believe that every digital solution must create a wonderful user experience from start to finish, built with outstanding design, and entwined with an elegant codebase.'
  },
  {
    url: 'visit',
    title: 'Visit us | 7glyphs',
    description: '7 glyphs Ltd. was founded on our love of web and mobile. Based in Auckland, New Zealand. We service the World.'
  },
  {
    url: 'brief',
    title: 'Brief us | 7glyphs',
    description: '7 glyphs Ltd. was founded on our love of web and mobile. Talk to us at 7 glyphs and our team of experts will discuss how we can make your vision possible.'
  },
  {
    url: 'join',
    title: 'Join us | 7glyphs',
    description: 'We are a team of awesome, inspired, creative people who enjoy what they do and take pride in their job. Our main capital is our team and we’re always looking for fresh talent.'
  }
]
